import { render, staticRenderFns } from "./DailyRecords.vue?vue&type=template&id=7f6e48f8&scoped=true"
import script from "./DailyRecords.vue?vue&type=script&lang=js"
export * from "./DailyRecords.vue?vue&type=script&lang=js"
import style0 from "./DailyRecords.vue?vue&type=style&index=0&id=7f6e48f8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f6e48f8",
  null
  
)

export default component.exports